<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="根据日期生成日点检项目"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="日期">
          <el-date-picker
              v-model="data"
              type="month"
              placeholder="选择日期"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="exportLoading" type="primary" @click="addByDate">生成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    components: {},
    data() {
      return {
        dialogVisible: false,
        exportLoading: false,
        data: "",
        ruleValidate: {
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
      },
      transformation(s) {
        return s<10 ? "0" + s:s;
      },
      addByDate() {
        const d = this.data;
        const date = d.getFullYear()+"-"+this.transformation((d.getMonth()+1));
        console.log(date.toString());
        let params = {
          date: date.toString(),
        };
        this.exportLoading = true;
        this.$http
          .get("basic","emEquipmentcheckrecords/addByDate",params).then(() => {
            this.getList(-1);
            this.$message.success("生成成功");
            this.$emit("save-success");
            this.dialogVisible = false;
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
